var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJustTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BEE8C99-E42D-4F87-83B7-84B12E5C0628") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Accounts-Health-System-Info-Copy-12",
    transform: "translate(-511.000000, -416.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(504.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7165495,243.14666 C18.8251733,243.923094 18.00571,244.742557 17.186144,245.590801 C16.3810325,246.439147 15.5902471,247.301743 14.8282423,248.193119 C13.7068012,249.530171 12.6284924,250.924835 11.622071,252.36258 L7.97019873,248.437536 C7.79770014,248.250598 7.51017169,248.193132 7.28010682,248.336845 C7.0069096,248.495002 6.92067058,248.840107 7.07882766,249.113176 C7.07882766,249.113176 10.5581705,255.108572 10.701945,255.367367 C10.8457606,255.61177 11.1620747,256 11.8090343,256 C12.4416678,256 12.7866495,255.626212 12.9880365,255.237995 C13.2036572,254.835427 15.1303022,251.269819 16.3811147,249.386373 C16.9992936,248.437436 17.6750338,247.517279 18.3507996,246.611525 C19.0408915,245.70572 19.759764,244.814344 20.4930653,243.980452 L20.5074065,243.966111 C20.694244,243.721707 20.694244,243.40539 20.5073062,243.189677 C20.3060557,242.959722 19.9466144,242.931042 19.7165495,243.14666 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustTick);
export default __webpack_public_path__ + "static/media/just-tick.36997ca6c15fd14873099191972e89b2.svg";
export { ForwardRef as ReactComponent };